/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListScreeningFieldType } from './InternalApiCustomListScreeningFieldType';
import {
    InternalApiCustomListScreeningFieldTypeFromJSON,
    InternalApiCustomListScreeningFieldTypeFromJSONTyped,
    InternalApiCustomListScreeningFieldTypeToJSON,
    InternalApiCustomListScreeningFieldTypeToJSONTyped,
} from './InternalApiCustomListScreeningFieldType';

/**
 * 
 * @export
 * @interface InternalApiCustomListScreeningFieldWithList
 */
export interface InternalApiCustomListScreeningFieldWithList {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    code?: string;
    /**
     * 
     * @type {InternalApiCustomListScreeningFieldType}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    type?: InternalApiCustomListScreeningFieldType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    rule?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    customListId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningFieldWithList
     */
    customListName: string;
}



/**
 * Check if a given object implements the InternalApiCustomListScreeningFieldWithList interface.
 */
export function instanceOfInternalApiCustomListScreeningFieldWithList(value: object): value is InternalApiCustomListScreeningFieldWithList {
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customListId' in value) || value['customListId'] === undefined) return false;
    if (!('customListName' in value) || value['customListName'] === undefined) return false;
    return true;
}

export function InternalApiCustomListScreeningFieldWithListFromJSON(json: any): InternalApiCustomListScreeningFieldWithList {
    return InternalApiCustomListScreeningFieldWithListFromJSONTyped(json, false);
}

export function InternalApiCustomListScreeningFieldWithListFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListScreeningFieldWithList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'path': json['path'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'type': json['type'] == null ? undefined : InternalApiCustomListScreeningFieldTypeFromJSON(json['type']),
        'rule': json['rule'] == null ? undefined : json['rule'],
        'customListId': json['customListId'],
        'customListName': json['customListName'],
    };
}

export function InternalApiCustomListScreeningFieldWithListToJSON(json: any): InternalApiCustomListScreeningFieldWithList {
    return InternalApiCustomListScreeningFieldWithListToJSONTyped(json, false);
}

export function InternalApiCustomListScreeningFieldWithListToJSONTyped(value?: InternalApiCustomListScreeningFieldWithList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'path': value['path'],
        'name': value['name'],
        'code': value['code'],
        'type': InternalApiCustomListScreeningFieldTypeToJSON(value['type']),
        'rule': value['rule'],
        'customListId': value['customListId'],
        'customListName': value['customListName'],
    };
}

